export default "__VITE_ASSET__CIEu6bbh__"